/* Bhairav Tatva v7 — desktop filter bar: each filter group becomes a pill that opens a small panel. Loads after bt.js. */
(() => {
  const caret = '<svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  let openGroup = null;
  const close = () => {
    if (!openGroup) return;
    openGroup.classList.remove('is-open');
    const b = openGroup.querySelector('.bt-flx');
    if (b) b.setAttribute('aria-expanded', 'false');
    openGroup = null;
  };
  const sync = (fs) => {
    const b = fs.querySelector('.bt-flx');
    if (!b) return;
    const n = fs.querySelectorAll('input:checked').length;
    b.querySelector('.bt-flx__n').textContent = n ? String(n) : '';
    b.classList.toggle('has-sel', n > 0);
  };
  const init = () => document.querySelectorAll('.bt-gcol .bt-fl__group').forEach((fs, k) => {
    if (fs.querySelector('.bt-flx')) return;
    const legend = fs.querySelector('legend');
    const opts = fs.querySelector('.bt-fl__opts');
    if (!legend || !opts) return;
    if (!opts.id) opts.id = `BtFlx-${k}`;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'bt-flx';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-controls', opts.id);
    b.innerHTML = `<span></span><span class="bt-flx__n"></span>${caret}`;
    b.firstChild.textContent = legend.textContent.trim();
    b.addEventListener('click', () => {
      const was = openGroup === fs;
      close();
      if (!was) { fs.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); openGroup = fs; }
    });
    fs.insertBefore(b, legend.nextSibling);
    fs.addEventListener('change', () => sync(fs));
    sync(fs);
  });
  document.addEventListener('click', (e) => { if (openGroup && !openGroup.contains(e.target)) close(); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !openGroup) return;
    const b = openGroup.querySelector('.bt-flx');
    close();
    if (b) b.focus();
  });
  document.addEventListener('bt:grid', () => document.querySelectorAll('.bt-gcol .bt-fl__group').forEach(sync));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
